module.exports = __webpack_public_path__ + "img/icon_earth.ef1418d3.png";